module.exports = __webpack_public_path__ + "img/12.67f19d0d.svg";